import { format, isBefore } from 'date-fns';
import { createSelector } from 'reselect';

import { getCoursesByClassAndSubject } from 'store/courses/selectors';

import { COURSE_CALENDAR_EDITOR_INITIAL_STATE } from './constants';
import { CalendarCourse, CourseCalendarEditor } from './typings';

export const getCourseCalendarEditor = createSelector(
    [(storeState: any, editorId: string) => storeState.courseCalendar[editorId]],
    (editor?: CourseCalendarEditor): CourseCalendarEditor => editor || COURSE_CALENDAR_EDITOR_INITIAL_STATE
);

export const getCalendarCourses = createSelector(
    [
        (storeState: any, classId: string, subject: string) =>
            getCoursesByClassAndSubject(storeState, { classId, subject }),
    ],
    (courses): CalendarCourse[] => {
        let firstCourseIndex: number | null = null;
        let prevCourseStart: Date;

        const calendarCourses = courses.map(({ id, date_closed: end, date_created: start }, index) => {
            const startDate = new Date(start);
            const endDate = end ? new Date(end) : undefined;

            if (!prevCourseStart) {
                firstCourseIndex = index;
                prevCourseStart = startDate;
            } else if (isBefore(startDate, prevCourseStart)) {
                firstCourseIndex = index;
            }

            return {
                courseId: id,
                start: format(startDate, 'yyyy-MM-dd') as string | undefined,
                end: endDate ? format(endDate, 'yyyy-MM-dd') : undefined,
            };
        });

        // https://st.yandex-team.ru/EDUCATION-24623
        // убираем дату старта, что бы коррекно запрашивать подписочные занятия дня новых пользователей
        if (calendarCourses.length && typeof firstCourseIndex === 'number') {
            calendarCourses[firstCourseIndex].start = undefined;
        }

        return calendarCourses;
    }
);
